import Link from "next/link";
import Image from "next/image";
import useTranslation from "next-translate/useTranslation";

const BecomeConsultantHero = () => {
  const { t } = useTranslation("become-consultant");

  return (
    <div className="bg-purple-800">
      <div className="container grid grid-cols-1 lg:grid-cols-2 lg:gap-x-6 gap-y-8 lg:gap-y-28 justify-items-end items-center py-4 lg:py-16">
        <div className="space-y-5 md:space-y-6 lg:space-y-12">
          <h1 className="font-title text-2xl md:text-3xl lg:text-6xl font-bold text-center lg:text-left">{t`title`}</h1>
          <p className="font-sans text-xs md:text-lg lg:text-xl leading-5 lg:leading-[2.25rem] text-center lg:text-left text-grey-800">{t`subtitle`}</p>
          <Link href="/register/start" passHref>
            <button type="button" className="block mx-auto lg:mx-0 button-lg hover-orange">
              {t`start-now`}
            </button>
          </Link>
        </div>
        <div className="relative order-first lg:order-none place-self-center lg:place-self-auto w-[327.44px] lg:w-[549px] h-[300px] lg:h-[503px]">
          <Image
            src="/become-consultant/hero.png"
            alt="People Connections"
            layout="fill"
            objectFit="cover"
            quality={100}
          />
        </div>
        <div className="col-span-full justify-self-center pt-10 lg:pt-0 text-center">
          <h2 className="text-xl lg:text-4xl font-semibold text-center whitespace-pre-line">{t`for-whom-is-vialantis`}</h2>
          <div className="my-4 lg:my-16 text-sm lg:text-xl leading-5 lg:leading-[2.25rem] text-grey-800">
            #Influenzer, #Therapeuten, #Coaches, #Kartenleger, #Psychologen, #Hellseher, #Yogalehrer, #Personaltrainer,
            #Musiklehrer, #Hebammen, #Autoren, #Schriftsteller, #Ernährungsberater, #Schamanen, #Traumdeuter, #Anwälte,
            #Ärzte, #Immobilienmakler, #Journalisten, #Heilpraktiker, #Hochzeitsplaner, #Steuerberater, #Pädagogen,
            #Nachhilfelehrer, #Theologen, #Künstler, #Fotografen, #Weltverbesserer u.v.a.m.
          </div>
        </div>
      </div>
    </div>
  );
};

export default BecomeConsultantHero;
